import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfo } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfo';
import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageSender } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageSender';
import type { ChatRoomListResponsePageAllOfThreeContentItemLastMessageStatus } from './chatRoomListResponsePageAllOfThreeContentItemLastMessageStatus';

/**
 * 마지막 메시지
 */
export type ChatRoomListResponsePageAllOfThreeContentItemLastMessage = {
  basicInfo?: ChatRoomListResponsePageAllOfThreeContentItemLastMessageBasicInfo;
  /** 발신자 정보 */
  sender?: ChatRoomListResponsePageAllOfThreeContentItemLastMessageSender;
  /** 메시지 상태 정보 */
  status?: ChatRoomListResponsePageAllOfThreeContentItemLastMessageStatus;
};
